import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "today_schedule" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "schedule_box"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "今日所有课程", -1)
const _hoisted_5 = {
  key: 2,
  class: "schedule_list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_head_top = _resolveComponent("head-top")!
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_head_top, { title: "今日课表" }),
    _createElementVNode("div", _hoisted_2, _toDisplayString($data.statusTitle), 1),
    (Object.keys($data.curSchedule) != 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString($data.curSchedule.CourseName), 1),
            _createElementVNode("span", null, "第" + _toDisplayString($data.curSchedule.CSLesson) + "课节", 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString($data.curSchedule.TeacherName) + " | " + _toDisplayString($data.curSchedule.ClsRoomName), 1),
            _createElementVNode("span", null, _toDisplayString($data.curSchedule.LessonClsTime) + "~" + _toDisplayString($data.curSchedule.LessonOutTime), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString($data.curSchedule.ClassName), 1)
          ])
        ]))
      : (_openBlock(), _createBlock(_component_van_empty, {
          key: 1,
          description: "暂无数据"
        })),
    _hoisted_4,
    ($data.scheduleList.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.scheduleList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "schedule_box",
              key: index
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(item.CourseName), 1),
                _createElementVNode("span", null, "第" + _toDisplayString(item.CSLesson) + "课节", 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(item.TeacherName) + " | " + _toDisplayString(item.ClsRoomName), 1),
                _createElementVNode("span", null, _toDisplayString(item.LessonClsTime) + "~" + _toDisplayString(item.LessonOutTime), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(item.ClassName), 1)
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock(_component_van_empty, {
          key: 3,
          description: "暂无数据"
        })),
    _createElementVNode("div", {
      class: "schedule_icon",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace('/schedule/my')))
    }, [
      _createVNode(_component_van_icon, { name: "notes-o" })
    ])
  ]))
}